<div class="payments-scheduled-bundle">
  <div class="row">
    <div class="column twelve">
      @if (bundledPayments.length) {
        <div class="row">
          <div class="column twelve">
            <hr aria-hidden="true" class="dashed" />
            <div class="Table">
              <div class="Table-row Table-header">
                <div class="Table-row-item">
                  <span dsContent [contentPath]="'billing.paymentHistory.billingAccount'"></span>
                </div>
                <div class="Table-row-item">
                  <span
                    dsContent
                    [contentPath]="'billing.paymentHistory.billingAccountNumber'"
                  ></span>
                </div>
                <div class="Table-row-item">
                  <span dsContent [contentPath]="'billing.paymentHistory.amount'"></span>
                </div>
              </div>
              @for (payment of bundledPayments; track payment) {
                <div class="Table-row">
                  <div class="Table-row-item" data-header="Billing Account">
                    {{ payment.nickName }}
                  </div>
                  <div class="Table-row-item" data-header="Billing Account Number">
                    {{ payment.billAccountNumber | prettyBillingAcctNum }}
                  </div>
                  <div class="Table-row-item" data-header="Amount">
                    {{ payment.billAcctPaymentAmount | currency: 'USD' : 'symbol' : '1.2-2' }}
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
